import { Link as RouterLink } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AnimateButton from 'components/extended/AnimateButton';
import { MotionDiv } from './MotionDiv';

export const MainAction = ({ text, icon, color, full = true }) => {
	const ActionButton = (
		<AnimateButton>
			<Button
				component={RouterLink}
				to='/'
				target='_blank'
				size={'medium'}
				variant='contained'
				color={color || 'primary'}
				startIcon={icon || <ScheduleIcon />}
				sx={{ fontSize: 16, fontFamily: 'Itim, handwriting' }}>
				{text}
			</Button>
		</AnimateButton>
	);

	return full ? (
		<MotionDiv delay='0.4'>
			<Grid container spacing={2} sx={{ justifyContent: { xs: 'center', lg: 'flex-end' } }}>
				<Grid item>{ActionButton}</Grid>
			</Grid>
		</MotionDiv>
	) : (
		<MotionDiv delay='0.4'>{ActionButton}</MotionDiv>
	);
};
